import http from "./http.js";

async function getManagersPayments(dateFrom, dateTo) {
  try {
    const response = await http.get(
      `payments-by-managers?monthFrom=${dateFrom}&monthTo=${dateTo}`
    );
    return response.data.map(p => {
      return {
        month: p.month,
        manager: p.manager
          ? { id: p.manager.id, title: p.manager.title }
          : null,
        amount: p.totalAmount,
        paymentsForPackage: p.paymentsForPackage,
      };
    });
  } catch (err) {
    throw err;
  }
}

export { getManagersPayments };
